import store from "@/redux/store";

import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { Overview } from "@/views/Invoice/Overview";
import { Create } from "@/views/Invoice/Create";

import {INVOICE} from "@/actions/globalConst";
import { invoiceInit,getInvoices,resetState } from '@/reducers/Invoice'

class InvoiceController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null, prevType: props.type };
  }
    
    componentDidMount =() => {
        const {location} = this.props;
        const {navigate} = this.props;
        const {InvoiceReducer} = this.props;
        
     //if(InvoiceReducer.api_state == "api_init") {
         if( location.pathname.includes("create") ) {
         store.dispatch( invoiceInit() )
         } else if( location.pathname == "/invoices" ) {
         store.dispatch( getInvoices() )
         
     } else {
         store.dispatch( resetState() )
         
     }
        
//          store.dispatch(invoiceInit());
        
    }
    
    getView =()=> {
        const {view} = this.props;
        const {InvoiceReducer, invoice} = this.props;
        let selectedView = "";
        
        
//            const {view} = InvoiceReducer;  
//        if(INVOICE.IS_READY) {
            selectedView = ( <Overview data={InvoiceReducer.invoices} doc={InvoiceReducer.doc}  /> );
            switch (view){
                case "create":
                    selectedView = ( <Create key={invoice?.uid} {...this.props} data={InvoiceReducer} invoice={invoice} /> );
                    break;
            }    
//        }        
        return selectedView;
    }
    
  render() {
    return this.getView();
  }
}

const InvoiceControllerInit = (props) => {
    const {InvoiceReducer} = props;
    const navigate = useNavigate();
    let location = useLocation();

    
  return (
    <InvoiceController
      {...props} location={location} navigate={navigate}
    />
  );
};

function mapStateToProps(state) {
    const {UserReducer, InvoiceReducer} = state;
    const {invoice} = InvoiceReducer;
//    if(InvoiceReducer.view == INVOICE.VIEW_CREATE) {
//        navigate("create", {"replace": true});
//    }
  return {
      UserReducer,
      InvoiceReducer,
      invoice
  };
}
export default connect(mapStateToProps)(InvoiceControllerInit);
